import {
  DEFAULT_ITEMS_LIMIT,
  DEFAULT_PADDING,
  DEFAULT_TEXT_ALIGN,
  TEXT_ALIGN_OPTIONS,
  defaultPaddingFor,
} from "./blockItems";

const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const DEFAULT_BACKGROUND = "#FFFFFF";
const DEFAULT_TEXT_COLOR = "#000000";

const BASE_STYLES = `
  body { margin: 0; font-family: Arial, Helvetica, sans-serif; color: #212121; }
  .container { width: 100%; margin: 0 auto; }
  .row { display: flex; flex-wrap: wrap; }
  .col { flex: 1 1 0; }
  .bloc { padding: 24px; }
  .ms-4 { margin-left: 16px; }
  .me-4 { margin-right: 16px; }
  .text-start { text-align: left; }
  .d-block { display: block; }
  .mx-auto { margin-left: auto; margin-right: auto; }
  .img-fluid, .img-100, .img-fluid-up { width: 100%; height: auto; }
  .w-100 { width: 100%; }
  .d-inline-block { display: inline-block; }
  .carousel { position: relative; }
  .carousel-inner { position: relative; overflow: hidden; }
  .carousel-item { display: none; }
  .carousel-item.active { display: block; }
  .carousel-item img { width: 100%; height: auto; }
  .carousel-indicators { position: absolute; bottom: 14px; left: 0; right: 0; z-index: 2; display: flex; justify-content: center; gap: 8px; margin: 0; padding: 0; list-style: none; }
  .carousel-indicators li { width: 32px; height: 3px; border-radius: 2px; background: #FFFFFF; opacity: 0.5; }
  .carousel-indicators li.active { opacity: 1; }
  .carousel-nav-controls { position: absolute; top: 50%; transform: translateY(-50%); z-index: 2; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; color: #FFFFFF; text-decoration: none; filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.35)); }
  .carousel-control-prev { left: 10px; }
  .carousel-control-next { right: 10px; }
  .carousel-nav-icon { fill: none; stroke: currentColor; stroke-width: 2; }
  .carousel-caption { position: absolute; bottom: 20px; left: 15%; right: 15%; color: #FFFFFF; }
  .visually-hidden { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; }
  .blocs-grid-container { display: grid; gap: 16px; }
  .grid-hover-zoom > div { transition: transform 0.25s ease; }
  .grid-hover-zoom > div:hover { transform: scale(1.04); }
  .mb-0 { margin-bottom: 0; }
  .mt-2 { margin-top: 8px; }
  .mb-4 { margin-bottom: 24px; }
  .mt-5 { margin-top: 48px; }
  .mb-5 { margin-bottom: 48px; }
  .divider-h { border-top: 1px solid #DEDEDE; }
  .tc-3351 { color: #454545; }
  .medium { font-size: 13px; }
  .h3-pavadinimas { font-size: 24px; font-weight: 700; color: #1B2A4A; margin-top: 0; }
  .mb-3 { margin-bottom: 16px; }
  .ps-2 { padding-left: 8px; }
  .pe-2 { padding-right: 8px; }
  .ms-0 { margin-left: 0; }
  .me-0 { margin-right: 0; }
  .blocs-horizontal-scroll-container { position: relative; display: flex; align-items: center; gap: 8px; }
  .blocs-horizontal-scroll-area { display: flex; gap: 16px; overflow-x: auto; scroll-behavior: smooth; }
  .slider-div { flex: 0 0 auto; width: 200px; }
  .slider-img { width: 100%; height: auto; }
  .blocs-horizontal-scroll-control { flex: 0 0 auto; cursor: pointer; }
  .blocs-round-btn { display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px; border-radius: 50%; background: #FFFFFF; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2); }
  .horizontal-scroll-icon { fill: none; stroke: #454545; stroke-width: 2; }
  .card { background: #FFFFFF; border: 1px solid #E5E7EB; height: 100%; }
  .card-size-2 { flex: 0 0 auto; width: 224px; }
  .card-body { padding: 16px; }
  .bold { font-weight: 700; }
  .text-center { text-align: center; }
  .price-style { font-size: 20px; font-weight: 700; text-align: center; }
  .lizingas-style { font-size: 13px; color: #00A3E0; text-align: center; }
  .small { font-size: 12px; }
  .label-size { width: 44px; }
  .me-1 { margin-right: 4px; }
  .mb-lg-2 { margin-bottom: 8px; }
  .card-body img { max-width: 100%; }
  .card-body .img-fluid { width: auto; }
  blocsicon { display: inline-block; vertical-align: middle; }
  blocsicon svg { width: 14px; height: 12px; fill: #00A3E0; }
  .text-collapse-toggle { display: flex; justify-content: center; margin-top: 4px; cursor: pointer; list-style: none; }
  .text-collapse-toggle::-webkit-details-marker { display: none; }
  .text-collapse-toggle::marker { content: ""; }
  .text-collapse-toggle svg { transition: transform 0.2s ease; }
  .text-collapse[open] .text-collapse-toggle svg { transform: rotate(180deg); }
  .text-collapse-area { margin-top: 8px; }
  .text-collapse-icon { fill: none; stroke: #1B2A4A; stroke-width: 2; }
  .category-grid-container { display: grid; gap: 12px 8px; }
  .category-grid-cell { min-width: 0; display: flex; }
  .category-grid-cell a { display: flex; width: 100%; text-decoration: none; color: inherit; }
  .category-grid-card { flex: 1 1 auto; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: space-between; background: #FFFFFF; border: 1px solid #E5E5E5; padding: 16px 12px 14px; }
  .category-grid-media { display: flex; align-items: center; justify-content: center; width: 100%; height: 104px; }
  .category-grid-media picture { display: block; max-height: 104px; }
  .category-grid-img { width: auto; height: auto; max-width: 100%; max-height: 104px; transform: scale(0.9); transition: transform 0.25s ease; }
  .category-grid-cell:hover .category-grid-img, .category-grid-cell:focus-within .category-grid-img { transform: scale(1); }
  .category-grid-title { margin: 14px 0 0; font-size: 11px; line-height: 1.3; text-align: center; }
  .preview-grid { display: grid; gap: 16px; }
  .preview-note { padding: 24px; color: #727272; font-size: 13px; text-align: center; }
  .preview-title { font-size: 18px; font-weight: 700; margin: 0 0 8px; }
  .preview-text { white-space: pre-wrap; margin: 0 0 16px; }
  .preview-collapsed { border: 1px solid #EFEFEF; border-radius: 4px; padding: 12px; }
  .preview-collapsed summary { cursor: pointer; font-weight: 700; }
`;

const linked = (html, url) =>
  url ? `<a href="${escapeHtml(url)}" rel="noopener">${html}</a>` : html;

const sourceType = (url) =>
  /\.webp(\?|$)/i.test(url || "") ? ' type="image/webp"' : "";

const picture = (item) => {
  const desktop = escapeHtml(item.desktop_image || "");
  const mobile = escapeHtml(item.mobile_image || item.desktop_image || "");

  return `<picture>
  <source${sourceType(item.desktop_image)} srcset="${desktop}" media="(min-width: 768px)">
  <source${sourceType(item.mobile_image || item.desktop_image)} srcset="${mobile}" media="(max-width: 767px)">
  <img src="${desktop}" class="img-fluid mx-auto d-block img-100 img-fluid-up" alt="${escapeHtml(
    item.title || "banner"
  )}">
</picture>`;
};

const heroBanner = (block, items) =>
  items
    .map(
      (item, index) => `<div class="bloc bgc-3893 l-bloc b-divider-dashed none full-width-bloc" id="bloc-${index}">
  <div class="container bloc-sm bloc-md-lg bloc-md-md">
    <div class="row">
      <div class="col text-start ms-4 me-4">
        ${linked(picture(item), item.destination_url)}
      </div>
    </div>
  </div>
</div>`
    )
    .join("\n");

const gridPicture = (item, extraClasses = "") => {
  const image = escapeHtml(item.desktop_image || "");

  return `<picture><source${sourceType(
    item.desktop_image
  )} srcset="${image}"><img src="${image}" class="img-fluid mx-auto d-block${
    extraClasses ? ` ${extraClasses}` : ""
  }" alt="${escapeHtml(item.title || "placeholder image")}"></picture>`;
};

const heading = (text, extraClasses = "") =>
  `<h3 class="mb-4 h3-pavadinimas tc-3351${
    extraClasses ? ` ${extraClasses}` : ""
  }">${escapeHtml(text)}</h3>`;

const blockHeading = (block, extraClasses = "") =>
  block.settings?.show_local_name !== false && block.local_name
    ? heading(block.local_name, extraClasses)
    : "";

const itemHeading = (item) =>
  item.show && item.title ? heading(item.title) : "";

const SCROLL_PREV_ICON =
  '<span class="blocs-round-btn"><svg width="26" height="26" viewBox="0 0 32 32"><path class="horizontal-scroll-icon" d="M22,2L9,16,22,30"></path></svg></span>';
const SCROLL_NEXT_ICON =
  '<span class="blocs-round-btn"><svg width="26" height="26" viewBox="0 0 32 32"><path class="horizontal-scroll-icon" d="M10.344,2l13,14-13,14"></path></svg></span>';

const sliderBlock = (block, items) => `<div class="bloc bgc-3893 l-bloc b-divider-dashed none full-width-bloc" id="bloc-0-${
  block.id || 0
}">
  <div class="container bloc-sm bloc-md-lg bloc-md-md">
    <div class="row">
      <div class="col text-start ps-2 pe-2">
        ${blockHeading(block, "ms-4 me-4")}
        <div class="blocs-horizontal-scroll-container">
          <div class="blocs-horizontal-scroll-control blocs-scroll-control-prev">
            ${SCROLL_PREV_ICON}
          </div>
          <div class="blocs-horizontal-scroll-area ms-4 me-4" style="overflow-x: auto; display: flex;">
            ${items
              .map(
                (item) => `<div class="slider-div">
              ${linked(
                gridPicture(item, "slider-img ms-0 me-0"),
                item.destination_url
              )}
              ${
                item.show && item.title
                  ? `<p class="mb-3 tc-3351 medium">${escapeHtml(
                      item.title
                    )}</p>`
                  : ""
              }
            </div>`
              )
              .join("\n            ")}
          </div>
          <div class="blocs-horizontal-scroll-control blocs-scroll-control-next">
            ${SCROLL_NEXT_ICON}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`;

const gridBanner = (block, items) => {
  const columns = Math.max(parseInt(block.columns_count, 10) || 1, 1);
  const localName = blockHeading(block);
  const zoomClass =
    block.settings?.hover_animation === true ? " grid-hover-zoom" : "";

  return `<div class="bloc bgc-3893 l-bloc b-divider-dashed none full-width-bloc" id="bloc-0-${
    block.id || 0
  }">
  <div class="container bloc-sm bloc-md-lg bloc-md-md">
    <div class="row">
      <div class="col text-start ms-4 me-4">
        ${localName}
        <div class="blocs-grid-container grid-style${zoomClass}" style="grid-template-columns: repeat(${columns}, minmax(0, 1fr));">
          ${items
            .map(
              (item) => `<div>
            ${linked(gridPicture(item), item.destination_url)}
            ${
              item.show && item.title
                ? `<p class="mt-2 tc-3351 medium mb-0">${escapeHtml(
                    item.title
                  )}</p>`
                : ""
            }
          </div>`
            )
            .join("\n          ")}
        </div>
      </div>
    </div>
  </div>
</div>`;
};

const categoryBannerGrid = (block, items) => {
  const columns = Math.max(parseInt(block.columns_count, 10) || 1, 1);

  return `<div class="bloc bgc-3893 l-bloc b-divider-dashed none full-width-bloc" id="bloc-0-${
    block.id || 0
  }">
  <div class="container bloc-sm bloc-md-lg bloc-md-md">
    <div class="row">
      <div class="col text-start ms-4 me-4">
        ${blockHeading(block)}
        <div class="category-grid-container" style="grid-template-columns: repeat(${columns}, minmax(0, 1fr));">
          ${items
            .map(
              (item) => `<div class="category-grid-cell">${linked(
                `<div class="category-grid-card">
              <div class="category-grid-media">${gridPicture(
                item,
                "category-grid-img"
              )}</div>
              ${
                item.show && item.title
                  ? `<p class="category-grid-title tc-3351">${escapeHtml(
                      item.title
                    )}</p>`
                  : ""
              }
            </div>`,
                item.destination_url
              )}</div>`
            )
            .join("\n          ")}
        </div>
      </div>
    </div>
  </div>
</div>`;
};

const imageGrid = (block, items) => {
  const columns = Math.min(Math.max(block.columns_count || 1, 1), 4);

  return `<div class="bloc">
  <div class="container">
    <div class="preview-grid" style="grid-template-columns: repeat(${columns}, minmax(0, 1fr));">
      ${items
        .map(
          (item) => `<div>
        ${linked(picture(item), item.destination_url)}
        ${
          item.show && item.title
            ? `<div class="preview-title">${escapeHtml(item.title)}</div>`
            : ""
        }
      </div>`
        )
        .join("\n")}
    </div>
  </div>
</div>`;
};

const carouselBlock = (block, items) => {
  const carouselId = `carousel-${block.id || 1}`;

  return `<div class="bloc bgc-3893 l-bloc b-divider-dashed none full-width-bloc" id="bloc-0-${
    block.id || 0
  }">
  <div class="container bloc-sm bloc-md-lg bloc-md-md">
    <div class="row">
      <div class="col text-start ms-4 me-4">
        <div id="${carouselId}" class="carousel slide" data-bs-ride="carousel">
          <ol class="carousel-indicators">
            ${items
              .map(
                (item, index) =>
                  `<li data-bs-target="#${carouselId}" data-bs-slide-to="${index}" class="${
                    index === 0 ? "active" : ""
                  }"${index === 0 ? ' aria-current="true"' : ""}></li>`
              )
              .join("\n            ")}
          </ol>
          <div class="carousel-inner" role="listbox">
            ${items
              .map(
                (item, index) => `<div class="carousel-item${
                  index === 0 ? " active" : ""
                }">
              <img class="d-inline-block w-100" alt="${escapeHtml(
                item.title || `slide ${index + 1}`
              )}" src="${escapeHtml(item.desktop_image || "")}">
              <div class="carousel-caption"></div>
            </div>`
              )
              .join("\n            ")}
          </div><a class="carousel-nav-controls carousel-control-prev" href="#${carouselId}" role="button" data-bs-slide="prev"><svg width="26" height="26" viewBox="0 0 32 32"><path class="carousel-nav-icon carousel-prev-icon" d="M22,2L9,16,22,30"></path></svg><span class="visually-hidden">Previous</span></a><a class="carousel-nav-controls carousel-control-next" href="#${carouselId}" role="button" data-bs-slide="next"><svg width="26" height="26" viewBox="0 0 32 32"><path class="carousel-nav-icon carousel-next-icon" d="M10.344,2l13,14-13,14"></path></svg><span class="visually-hidden">Next</span></a>
        </div>
      </div>
    </div>
  </div>
</div>`;
};

const imageRow = (block, items) => `<div class="bloc">
  <div class="container">
    <div class="row">
      ${items
        .map(
          (item) => `<div class="col">${linked(
            picture(item),
            item.destination_url
          )}</div>`
        )
        .join("\n")}
    </div>
  </div>
</div>`;

const blocWrapper = (block, body) => `<div class="bloc bgc-3893 l-bloc b-divider-dashed none full-width-bloc" id="bloc-0-${
  block.id || 0
}">
  <div class="container bloc-sm bloc-md-lg bloc-md-md">
    <div class="row">
      <div class="col text-start ms-4 me-4">
        ${blockHeading(block)}
        ${body}
      </div>
    </div>
  </div>
</div>`;

const htmlBlock = (block, items) =>
  blocWrapper(
    block,
    items
      .map((item) => `${itemHeading(item)}${item.content || ""}`)
      .join("\n        ")
  );

const paragraphs = (content) =>
  escapeHtml(content)
    .split(/\n{2,}/)
    .filter((paragraph) => paragraph.trim())
    .map(
      (paragraph) =>
        `<p class="mb-3 tc-3351">${paragraph.replace(/\n/g, "<br>")}</p>`
    )
    .join("\n          ");

const COLLAPSE_ICON =
  '<svg width="26" height="26" viewBox="0 0 32 32"><path class="text-collapse-icon" d="M2,10L16,23,30,10"></path></svg>';

const textAlign = (block) =>
  TEXT_ALIGN_OPTIONS.some((option) => option.value === block.settings?.text_align)
    ? block.settings.text_align
    : DEFAULT_TEXT_ALIGN;

const textBlock = (block, items) => {
  const align = textAlign(block);

  return blocWrapper(
    block,
    items
      .map((item) => {
        const title = itemHeading(item);
        const body = paragraphs(item.content || "");
        const hidden = paragraphs(item.hidden_content || "");

        if (!hidden) return `<div style="text-align: ${align}">${title}${body}</div>`;

        return `<div style="text-align: ${align}">${title}${body}<details class="text-collapse">
          <summary class="text-collapse-toggle">${COLLAPSE_ICON}</summary>
          <div class="text-collapse-area">${hidden}</div>
        </details></div>`;
      })
      .join("\n        ")
  );
};

const CARD_IMAGE =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="236" height="236">' +
      '<rect width="236" height="236" fill="#EDEFF2"/>' +
      '<rect x="78" y="88" width="80" height="60" rx="4" fill="#C9CFD8"/>' +
      '<circle cx="140" cy="106" r="8" fill="#EDEFF2"/>' +
      '<path d="M84 148l26-24 20 18 16-12 24 18z" fill="#EDEFF2"/>' +
      "</svg>"
  );

const CARD_LABEL =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="24">' +
      '<path d="M0 0h32l12 12-12 12H0z" fill="#F2A900"/>' +
      '<text x="10" y="17" font-family="Arial" font-size="12" fill="#FFFFFF">E</text>' +
      "</svg>"
  );

const CARD_FEATURES = [
  {
    label: "Pristatymas Lietuvuvoje 1-2 d.d.",
    viewBox: "0 0 640 512",
    path: "M112 0C85.5 0 64 21.5 64 48V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 272c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 240c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V416c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zM544 237.3V256H416V160h50.7L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z",
  },
  {
    label: "Yra standėlyje",
    viewBox: "0 0 640 512",
    path: "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM192 80V272c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H464V176c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V32H240c-26.5 0-48 21.5-48 48z",
  },
  {
    label: "Nemokamas 24 mėn. lizingas",
    viewBox: "0 0 576 512",
    path: "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z",
  },
  {
    label: "Nemokamas pristatymas",
    viewBox: "0 0 640 512",
    path: "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z",
  },
];

const productCard = (label) => `<div class="card-size-2">
              <div class="card card-sq">
                <div class="card-body">
                  <img src="${CARD_IMAGE}" class="img-fluid mx-auto d-block" alt="preke" width="236" height="236"><img src="${CARD_LABEL}" class="img-fluid mx-auto d-block label-size mb-lg-2" alt="energijos klase" width="44" height="24">
                  <p class="bold tc-3351 mb-4 text-center">${escapeHtml(
                    label || "Prekės pavadinimas"
                  )}<br></p>
                  <p class="price-style tc-3351 text-center mb-0">000,00 €</p>
                  <p class="mb-3 lizingas-style">00,00 € × 24 mėn.*</p>
                  ${CARD_FEATURES.map(
                    (feature) =>
                      `<p class="small mb-2"><blocsicon class="text-nested-icon me-1 svg-icon-fill"><svg viewBox="${feature.viewBox}"><path d="${feature.path}"></path></svg></blocsicon>&nbsp;${feature.label}<br></p>`
                  ).join("\n                  ")}
                </div>
              </div>
            </div>`;

const bestInCategory = (block, items) => {
  const limit = Math.max(
    parseInt(block.settings?.items_limit, 10) || DEFAULT_ITEMS_LIMIT,
    1
  );
  const skus = items
    .map((item) => item.code)
    .filter(Boolean)
    .slice(0, limit);
  const autoCount = Math.max(limit - skus.length, 0);

  const cards = [
    ...skus.map((sku) => productCard(sku)),
    ...Array.from({ length: autoCount }, () => productCard()),
  ].join("\n            ");

  const category = escapeHtml(block.category_code || "-");
  const note = !autoCount
    ? `Rodomos ${skus.length} pasirinktos prekės - kategorija nenaudojama.`
    : skus.length
    ? `Pirmos ${skus.length} - pasirinktos rankiniu būdu, likusios ${autoCount} paimamos iš kategorijos "${category}" perkamiausių.`
    : `Visos ${autoCount} prekės paimamos iš kategorijos "${category}" perkamiausių.`;

  return `<div class="bloc bgc-3893 l-bloc" id="bloc-${block.id || 0}">
  <div class="container bloc-lg bloc-lg-lg">
    <div class="row">
      <div class="col text-start">
        ${block.title ? heading(block.title) : ""}
        <div class="blocs-horizontal-scroll-container">
          <div class="blocs-horizontal-scroll-control blocs-scroll-control-prev">
            ${SCROLL_PREV_ICON}
          </div>
          <div class="blocs-horizontal-scroll-area" style="overflow-x: auto; display: flex;">
            ${cards}
          </div>
          <div class="blocs-horizontal-scroll-control blocs-scroll-control-next">
            ${SCROLL_NEXT_ICON}
          </div>
        </div>
        <div class="preview-note">${note}</div>
      </div>
    </div>
  </div>
</div>`;
};

const TEMPLATES = {
  hero_banner: heroBanner,
  grid_banner: gridBanner,
  category_banner_grid: categoryBannerGrid,
  carousel: carouselBlock,
  slider: sliderBlock,
  html: htmlBlock,
  text: textBlock,
  best_in_category: bestInCategory,
};

const HEIGHT_SCRIPT = `
  (function () {
    var report = function () {
      parent.postMessage(
        { type: "block-preview-height", height: document.documentElement.scrollHeight },
        "*"
      );
    };

    window.__reportPreviewHeight = report;
    window.addEventListener("load", report);
    document.addEventListener("DOMContentLoaded", function () {
      Array.prototype.forEach.call(document.images, function (image) {
        image.addEventListener("load", report);
        image.addEventListener("error", report);
      });
      if (window.ResizeObserver) new ResizeObserver(report).observe(document.body);
      report();
    });
    report();
  })();
`;

const PREVIEW_SCRIPT = `
  (function () {
    var report = function () {
      if (window.__reportPreviewHeight) window.__reportPreviewHeight();
    };

    Array.prototype.forEach.call(
      document.querySelectorAll(".text-collapse"),
      function (wrapper) {
        wrapper.addEventListener("toggle", report);
      }
    );

    Array.prototype.forEach.call(
      document.querySelectorAll(".blocs-horizontal-scroll-container"),
      function (container) {
        var area = container.querySelector(".blocs-horizontal-scroll-area");
        if (!area) return;

        var scrollBy = function (direction) {
          area.scrollLeft += direction * Math.max(area.clientWidth - 40, 120);
        };

        var prev = container.querySelector(".blocs-scroll-control-prev");
        var next = container.querySelector(".blocs-scroll-control-next");
        if (prev) prev.addEventListener("click", function () { scrollBy(-1); });
        if (next) next.addEventListener("click", function () { scrollBy(1); });
      }
    );

    Array.prototype.forEach.call(
      document.querySelectorAll(".carousel"),
      function (carousel) {
        var items = carousel.querySelectorAll(".carousel-item");
        var dots = carousel.querySelectorAll(".carousel-indicators li");
        if (items.length < 2) return;

        var current = 0;
        var show = function (index) {
          current = (index + items.length) % items.length;
          Array.prototype.forEach.call(items, function (item, i) {
            item.className = i === current ? "carousel-item active" : "carousel-item";
          });
          Array.prototype.forEach.call(dots, function (dot, i) {
            dot.className = i === current ? "active" : "";
          });
        };

        var timer = setInterval(function () { show(current + 1); }, 5000);
        var restart = function () {
          clearInterval(timer);
          timer = setInterval(function () { show(current + 1); }, 5000);
        };

        carousel.querySelectorAll(".carousel-control-prev").forEach(function (control) {
          control.addEventListener("click", function (event) {
            event.preventDefault();
            show(current - 1);
            restart();
          });
        });
        carousel.querySelectorAll(".carousel-control-next").forEach(function (control) {
          control.addEventListener("click", function (event) {
            event.preventDefault();
            show(current + 1);
            restart();
          });
        });
        Array.prototype.forEach.call(dots, function (dot, index) {
          dot.style.cursor = "pointer";
          dot.addEventListener("click", function () {
            show(index);
            restart();
          });
        });
      }
    );
  })();
`;

const activeItems = (block) =>
  [...(block.banner_block_items || [])]
    .sort((a, b) => (a.position || 0) - (b.position || 0))
    .filter((item) => item.active);

const AUTO_FILLED_TYPES = ["best_in_category"];

const blockBody = (block) => {
  const items = activeItems(block);
  const template = TEMPLATES[block.block_type];
  const needsItems = !AUTO_FILLED_TYPES.includes(block.block_type);

  return !template || (needsItems && !items.length)
    ? `<div class="preview-note">Nothing active to preview in this block.</div>`
    : template(block, items);
};

const paddingSize = (value, fallback) => {
  const padding = parseInt(value, 10);

  return Number.isNaN(padding) || padding < 0 ? fallback : padding;
};

const blockPadding = (block, selector) => {
  const fallback = defaultPaddingFor(block.background_color);
  const top = paddingSize(block.padding_top, fallback);
  const bottom = paddingSize(block.padding_bottom, fallback);
  const left = paddingSize(block.padding_left, DEFAULT_PADDING);
  const right = paddingSize(block.padding_right, DEFAULT_PADDING);

  return `${selector} .bloc { padding: ${top}px ${right}px ${bottom}px ${left}px; }`;
};

const blockStyles = (block, selector) => {
  const textColor = escapeHtml(
    (block.text_color || "").trim() || DEFAULT_TEXT_COLOR
  );
  const background = escapeHtml(
    (block.background_color || "").trim() || DEFAULT_BACKGROUND
  );

  return `${selector} { background: ${background}; color: ${textColor}; }
  ${selector} .tc-3351, ${selector} .h3-pavadinimas, ${selector} .price-style, ${selector} .card-body { color: ${textColor}; }
  ${selector} .text-collapse-icon { stroke: ${textColor}; }
  ${blockPadding(block, selector)}`;
};

const previewDocument = (styles, body) => `<!doctype html>
<html>
<head><meta charset="utf-8"><style>${BASE_STYLES}${styles}</style><script>${HEIGHT_SCRIPT}</script></head>
<body>${body}<script>${PREVIEW_SCRIPT}</script></body>
</html>`;

const infoZoneBlocks = (infoZone) =>
  (infoZone?.banner_block_links || [])
    .map((link) => link.banner_block)
    .filter(Boolean);

export const renderBlockPreview = (block) => {
  if (!block) return "";

  return previewDocument(blockStyles(block, "body"), blockBody(block));
};

export const renderInfoZonePreview = (infoZone) => {
  const blocks = infoZoneBlocks(infoZone);

  if (!blocks.length) {
    return previewDocument(
      `body { background: ${DEFAULT_BACKGROUND}; color: ${DEFAULT_TEXT_COLOR}; }`,
      `<div class="preview-note">This info zone has no blocks to preview.</div>`
    );
  }

  const sections = blocks.map((block, index) => {
    const className = `zone-block-${block.id || index}`;

    return {
      styles: blockStyles(block, `.${className}`),
      html: `<section class="${className}">${blockBody(block)}</section>`,
    };
  });

  return previewDocument(
    sections.map((section) => section.styles).join("\n"),
    sections.map((section) => section.html).join("\n")
  );
};

export default renderBlockPreview;

export const PREVIEW_SANDBOX =
  "allow-scripts allow-same-origin allow-popups allow-forms allow-presentation";

export const previewSrc = (html) =>
  `data:text/html;charset=utf-8,${encodeURIComponent(html || "")}`;
